<template>
    <div class="col-12">
        <v-card class="text-center" id="empty-price-period">
            <div class="d-inline-block w-100 room-card-box">
                <v-btn color="primary" text class="text-primary add-period-btn" @click="openModal()">
                    <v-icon class="text-primary" left>add</v-icon>
                    Ajouter une période tarifaire
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex"

export default {
    name: "AddButton",
    methods: {
        ...mapMutations('web_form', ['setAddPricePeriodDialog', 'setCurrentPricePeriod']),
        openModal() {
            let availableElements = this.getFamilyByCode('OfferType').map(element => {
                element.disabled = false

                return element
            })

            let period = {
                currency: this.currency,
                valid_from: null,
                valid_through: null,
                prices: [],
                availableElements: availableElements,
                selectedElements: [],
                uid: new Date().valueOf()
            }

            period.uid = Math.random().toString(36).substr(2, 16)

            this.setCurrentPricePeriod(period)
            this.setAddPricePeriodDialog(true)
        }
    },
    computed: {
        ...mapGetters('web_form', ['getFamilyByCode']),
        ...mapState('web_form', ['currency']),
        ...mapState('resource', ['currencies'])
    }
}
</script>